import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { siteStats } from '@/mocks/siteInfo';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20background%20with%20soft%20abstract%20geometric%20shapes%2C%20orange%20and%20coral%20tones%20blending%20seamlessly%2C%20modern%20minimalist%20style%20with%20gentle%20flowing%20curves%2C%20warm%20inviting%20atmosphere%2C%20subtle%20texture%20overlay&width=1800&height=600&seq=cta-bg-jmcomic-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 to-background-950/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          <div className="text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              准备好开始您的漫画之旅了吗？
            </h2>
            <p className="text-background-200/80 max-w-md text-sm">
              立即访问禁漫天堂 JMComic，加入{siteInfo.totalUsers}漫画爱好者的行列，探索海量精彩漫画世界。
            </p>
            <div className="flex items-center gap-6 mt-6 justify-center lg:justify-start flex-wrap">
              {siteStats.slice(0, 3).map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-300">{stat.value}</div>
                  <div className="text-xs text-background-300/70">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href={`https://${siteInfo.latestAddress}`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/40"
            >
              <i className="ri-rocket-line mr-2"></i>立即访问官网
            </a>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer border border-background-50/20"
            >
              <i className="ri-information-line mr-2"></i>了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}